import { useCurrentMaster } from '@lib/hooks';

export type TReseller = {
  reseller: string;
  integrators: string[];
  cobrandingRootAccount: string;
  maaRootAccounts: string[];
  quickstarts?: {
    [key: string]: string[];
  };
};

const getResellersFromEnv = (): TReseller[] => {
  try {
    // The environment variable is already a JSON string containing an array of resellers
    return JSON.parse(process.env.REACT_APP_RESELLER_PARTNERS || '[]') as TReseller[];
  } catch (error) {
    return [];
  }
};

export default function useCurrentMasterReseller() {
  const currentMaster = useCurrentMaster();
  if (!currentMaster) return null;

  const resellers = getResellersFromEnv();

  // When the User is a partner, it will not have the reseller on the salesforceData, but the master will be the reseller
  const partnerMasterReseller = resellers.find((reseller) => reseller.maaRootAccounts?.includes(currentMaster.id));
  if (partnerMasterReseller) return partnerMasterReseller;

  // customers that belong to a reseller will have the reseller on the salesforceData
  const currentMasterResellerID = (currentMaster.salesforceData as { reseller?: string })?.reseller;
  if (!currentMasterResellerID) return null;

  const currentMasterReseller = resellers.find((reseller) => reseller.reseller === currentMasterResellerID) || null;

  return currentMasterReseller;
}
